import React, {
  useEffect,
  useState,
} from "react";

import { useNavigate } from "react-router-dom";

import viewAllImg from "../assets/viewall.jpg";

const LifeAtSchool = () => {
  const navigate =
    useNavigate();

  const [data, setData] =
    useState([]);

  useEffect(() => {
    Promise.all([
      fetch(
        "https://stjosephweb.ilakshyaerp.in/api/academics"
      ).then((res) =>
        res.json()
      ),

      fetch(
        "https://stjosephweb.ilakshyaerp.in/api/galleryAwards"
      ).then((res) =>
        res.json()
      ),

      fetch(
        "https://stjosephweb.ilakshyaerp.in/api/birthday"
      ).then((res) =>
        res.json()
      ),

      fetch(
        "https://stjosephweb.ilakshyaerp.in/api/student"
      ).then((res) =>
        res.json()
      ),
    ])

      .then(
        ([
          academics,
          galleryAwards,
          birthday,
          student,
        ]) => {
          setData([
            {
              title:
                "Academics",

              img:
                academics?.[0]
                  ?.image
                  ? `https://stjosephweb.ilakshyaerp.in/uploads/academics/${academics[0].image}`
                  : "https://picsum.photos/400/300?1",

              desc:
                "Strong academic foundation with modern learning.",

              link:
                "/life?type=academics",
            },

            {
              title:
                "Gallery & Awards",

              img:
                galleryAwards?.[0]
                  ?.image
                  ? `https://stjosephweb.ilakshyaerp.in/uploads/galleryAwards/${galleryAwards[0].image}`
                  : "https://picsum.photos/400/300?2",

              desc:
                "Explore school memories and moments.",

              link:
                "/life?type=galleryAwards",
            },

            {
              title:
                "Birthday",

              img:
                birthday?.[0]
                  ?.image
                  ? `https://stjosephweb.ilakshyaerp.in/uploads/birthday/${birthday[0].image}`
                  : "https://picsum.photos/400/300?3",

              desc:
                "Celebrating students birthdays.",

              link:
                "/life?type=birthday",
            },

            {
              title:
                "Student Work",

              img:
                student?.[0]
                  ?.image
                  ? `https://stjosephweb.ilakshyaerp.in/uploads/student/${student[0].image}`
                  : "https://picsum.photos/400/300?4",

              desc:
                "Creative and academic student work.",

              link:
                "/life?type=student",
            },

            {
              title:
                "View All",

              img: viewAllImg,

              desc:
                "Explore all school life activities.",

              link:
                "/life?type=all",
            },
          ]);
        }
      )

      .catch(() =>
        console.log(
          "Life section fetch error"
        )
      );
  }, []);

  return (
    <section className="w-full bg-[#f7f9fc] py-20 overflow-x-hidden">

      <div className="max-w-7xl mx-auto px-5 md:px-10">

        {/* HEADING */}
        <div className="text-center mb-14">

          <span className="text-[#D4A017] uppercase tracking-[5px] text-sm font-bold">

            School Activities

          </span>

          <h2 className="text-4xl md:text-5xl font-extrabold text-[#072F5F] mt-4">

            LIFE AT
            <span className="text-[#0B4F9C]">
              {" "}
              SCHOOL
            </span>

          </h2>

        </div>

        {/* GRID */}
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-5">

          {data.map((item, i) => (
            <div
              key={i}
              onClick={() =>
                navigate(item.link)
              }
              className="group relative overflow-hidden rounded-[22px] shadow-lg cursor-pointer hover:-translate-y-2 transition-all duration-500"
            >

              {/* IMAGE */}
              <img
                src={item.img}
                alt={item.title}
                className="w-full h-[230px] md:h-[260px] object-cover group-hover:scale-105 transition-all duration-700"
              />

              {/* DARK OVERLAY */}
              <div className="absolute inset-0 bg-black/35 group-hover:bg-black/50 transition-all duration-500"></div>

              {/* CONTENT */}
              <div className="absolute bottom-0 left-0 w-full p-4">

                <h3 className="text-lg md:text-xl font-bold text-white">

                  {item.title}

                </h3>

                {/* BUTTON */}
                <button
                  onClick={(e) => {
                    e.stopPropagation();

                    navigate(
                      item.link
                    );
                  }}
                  className="mt-3 bg-[#0B4F9C] hover:bg-[#072F5F] text-white px-4 py-2 rounded-lg text-sm font-medium opacity-0 group-hover:opacity-100 transition-all duration-300"
                >

                  Read More

                </button>

              </div>

            </div>
          ))}

        </div>

      </div>

    </section>
  );
};

export default LifeAtSchool;